export default "__VITE_PUBLIC_ASSET__fdcbafc5__"